<div>
    <div class="row">
        <div class="col-xl-12">
            <div class="card-box">
                <div class="float-right">
                    <div class="dropdown">
                        <button class="btn btn-primary btn-sm dropdown-toggle" type="button" id="dropdownMen1" data-toggle="dropdown" data-boundary="viewport" aria-haspopup="true" aria-expanded="false">
                            Actions
                        </button>
                        <div class="dropdown-menu" aria-labelledby="dropdownMenu1">
                            <button class="dropdown-item" id="btnRescheduleDelivery" @click="viewOrderSchedule">
                                View Order In Delivery Batch
                            </button>
                            <button class="dropdown-item" id="btnEditSboDelivery" @click="onSboEditClick">
                                Edit SBO
                            </button>
                            <button class="dropdown-item" id="btnSboEditHistory" @click="onEditSboHistoryClick">
                                View SBO Edit History
                            </button>
                            <button class="dropdown-item" id="btnExportOrdersToExcel" @click="downloadScheduleAsPdf">
                                Download
                            </button>
                        </div>
                    </div>
<!--                    <button class="btn btn-primary" id="btnRescheduleDelivery" @click="rescheduleOrder">Reschedule</button>-->
                </div>
                <div v-if="!loading">
                    <div class="pb-2">
                        <p>
                            <b>Customer:</b> {{order.registeredCompanyName}}
                        </p>
                        <!--                        <p v-if="order.customerBranch">-->
                        <!--                            Branch: {{order.customerBranch}}-->
                        <!--                        </p>-->
                        <p>
                            <b>Order Date:</b> {{order.insertedOn}}
                        </p>
                        <p>
                            <b>Order Type:</b> {{order.orderType}}
                        </p>
                        <p>
                            <b>Order Status:</b> {{order.description}}
                        </p>
                        <!--                        <p v-if="order.placedBy">-->
                        <!--                            Placed By: {{order.placedBy}} (#{{order.placedByUserId}})-->
                        <!--                        </p>-->
                        <p v-if="order.expectedDeliveryDate !== null && order.expectedDeliveryDate !== undefined">
                            <b>Expected Date Of Delivery:</b> {{order.expectedDeliveryDate}}
                        </p>
                    </div>
                    <div class="card border border-secondary mb-3">
                        <div class="card-body text-secondary">
                            <div class="row">
                                <div class="col-6">
                                    <h5 class="card-title text-secondary">Vehicle Details</h5>
                                    <p>
                                        <span>
                                            Make: {{ vehicle.make }}<br>
                                            Model: {{ vehicle.model }}<br>
                                            Year: {{ vehicle.year }} <br>
                                            Capacity: {{ vehicle.capacity }} <br>
                                        </span>
                                    </p>
                                </div>
                                <div class="col-6">
                                    <h5 class="card-title text-secondary">Driver Details</h5>
                                    <p>
                                        <span>
                                            Name: {{ driver.firstName }} {{ driver.lastName }}<br>
                                            Driver ID: {{ driver.driverId }}<br>
                                            Phone Number: {{ driver.phoneNumber }}<br>
                                        </span>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="card border border-secondary mb-3">
                        <div class="card-body text-secondary">
                            <div class="row">
                                <div class="col-6">
                                    <h5 class="card-title text-secondary">Billing Address</h5>
                                    <p v-if="!loadingBillingAddress">
                                        <span v-if="billingAddress">
                                            {{ billingAddress.siteName }}<br>
                                            {{ billingAddress.streetAddress }}<br>
                                            {{ billingAddress.city }} <br>
                                            {{ billingAddress.province }} <br>
                                            {{ billingAddress.postalCode }}<br>
                                            <!--                                {{ billingAddress.country }}-->
                                        </span>
                                                <span v-else>
                                            No billing address found.
                                        </span>
                                    </p>
                                    <p v-if="loadingBillingAddress">Loading...</p>
                                </div>
                                <div class="col-6">
                                    <h5 class="card-title text-secondary">Shipping Address</h5>
                                    <p v-if="!loadingBillingAddress">
                                        <span v-if="shippingAddress">
                                            {{ shippingAddress.siteName }}<br>
                                            {{ shippingAddress.streetAddress }}<br>
                                            {{ shippingAddress.city }} <br>
                                            {{ shippingAddress.province }} <br>
                                            {{ shippingAddress.postalCode }}<br>
                                            <!--                                {{ billingAddress.country }}-->
                                        </span>
                                        <span v-else>
                                            No shipping address found.
                                        </span>
                                    </p>
                                    <p v-if="loadingBillingAddress">Loading...</p>
                                </div>
                            </div>
                            
                        </div>
                    </div>
                    <div class="card border border-secondary pt-2">
                        <div class="card-body text-secondary">
                            <h5 class="card-title text-secondary">Items Ordered</h5>
                            <order-items-table
                                    :orderId="orderId"
                                    :orderTotal="orderGrandTotal"></order-items-table>
                            
                        </div>
                    </div>
                </div>
                <loading-spinner :showSpinner="loading"></loading-spinner>
            </div>
        </div>
    </div>

    <modal-form
            :heading="sboModalEdit.heading"
            :modalId="sboModalEdit.modalId"
            :isSaving="sboModalEdit.isSaving"
            :showModal="sboModalEdit.showModal"
            @closeClicked="onSboEditCloseClick"
            @saveButtonClicked="onSboEditSaveClick">
        <template #form>
            <div class="form-group">
                <label for="sboInput">
                    SBO
                </label>
                <div class="text-danger" v-if="sboModalEdit.sbo.hasError">
                    {{sboModalEdit.sbo.errorMessage}}
                </div>
                <input type="text" class="form-control" id="sboInput" v-model="sboModalEdit.sbo.value">
            </div>
        </template>
    </modal-form>

    <success-modal
            :modalHeading="successModal.modalHeading"
            :elementId="successModal.elementId"
            :modalMessage="successModal.modalMessage"
            :showModal="successModal.showModal"
            @okClicked="successModelOkClicked"></success-modal>


    <div class="modal fade" id="editSboTrackingHistory" tabindex="-1" role="dialog" aria-labelledby="editSboTrackingHistoryLabel" aria-hidden="true">
        <div class="modal-dialog modal-lg" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="editSboTrackingHistoryLabel">SBO Edit History - #{{order.orderId}}</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="onSboHistoryOkClick">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <data-table :headings="sboEditHistoryHeadings" :data="sboEditHistory" :hasActions="false"
                                :hasNoFilter="true"
                                :hasNoPaging="true"></data-table>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-success" data-dismiss="modal" @click="onSboHistoryOkClick" :disabled="loading">OK</button>
                </div>
            </div>
        </div>
    </div>

    <modal-message
            :heading="'No Delivery Batch'"
            :elementId="'noBatchMessageModal'"
            :message="noDeliveryBatchModal.message"
            :showModal="noDeliveryBatchModal.showModal"
            @okClicked="onNoDeliveryBatchOkClick"></modal-message>
    
</div>
